style= require('./edit-team-source.styl')
.modal-header
  .modal-title='Override'
  ft-icon.close(name='ui--cross', (click)= this.closeModal())
if team
  .custom
    .block
      label Name
      ft-form-control(
        type="text",
        [(value)]=team.name)
    .block
      label Abbreviation
      ft-form-control(
        type="text",
        [(value)]=team.abbr)
    .block
      label Tag
      ft-form-control(
        type="text",
        [(value)]=team.tag)
    .block
      label Short Team Name
      ft-form-control(
        type="text",
        maxlength=10,
        [(value)]=team.shortTeamName)
    .block
      label N/A Toggle
      ft-toggle.sub(
        checked=team.notAvailable,
        (change)=this.toggleDisabled(team, e),
      ) N/A
  .modal-footer
    ft-button.save(success, (click)=this.closeModal(true))="Save"
